module.exports = __webpack_public_path__ + "assets/img/cloud6.1e0214eb.webp";